import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Guestbook API
export const guestbookAPI = {
  // Get all approved entries
  getEntries: async () => {
    try {
      const response = await axios.get(`${API}/guestbook/entries`);
      return response.data;
    } catch (error) {
      console.error('Error fetching entries:', error);
      throw error;
    }
  },

  // Create new entry
  createEntry: async (entryData) => {
    try {
      const response = await axios.post(`${API}/guestbook/entries`, entryData);
      return response.data;
    } catch (error) {
      console.error('Error creating entry:', error);
      throw error;
    }
  },

  // Upload image
  uploadImage: async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await axios.post(`${API}/guestbook/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data.image_url;
    } catch (error) {
      console.error('Error uploading image:', error);
      throw error;
    }
  },

  // Admin: Get all entries
  getAllEntries: async () => {
    try {
      const response = await axios.get(`${API}/guestbook/entries/all`);
      return response.data;
    } catch (error) {
      console.error('Error fetching all entries:', error);
      throw error;
    }
  },

  // Admin: Update coordinates
  updateCoordinates: async (entryId, coordinates) => {
    try {
      const response = await axios.put(`${API}/guestbook/entries/${entryId}/coordinates`, {
        coordinates: coordinates
      });
      return response.data;
    } catch (error) {
      console.error('Error updating coordinates:', error);
      throw error;
    }
  },

  // Admin: Delete entry
  deleteEntry: async (entryId) => {
    try {
      const response = await axios.delete(`${API}/guestbook/entries/${entryId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting entry:', error);
      throw error;
    }
  },
};

// Settings API
export const settingsAPI = {
  // Get site settings
  getSettings: async () => {
    try {
      const response = await axios.get(`${API}/settings`);
      return response.data;
    } catch (error) {
      console.error('Error fetching settings:', error);
      throw error;
    }
  },

  // Update site settings
  updateSettings: async (settings) => {
    try {
      const response = await axios.put(`${API}/settings`, settings);
      return response.data;
    } catch (error) {
      console.error('Error updating settings:', error);
      throw error;
    }
  },

  // Reset to defaults
  resetSettings: async () => {
    try {
      const response = await axios.post(`${API}/settings/reset`);
      return response.data;
    } catch (error) {
      console.error('Error resetting settings:', error);
      throw error;
    }
  },
};

export default guestbookAPI;
